<template>
  <Card class="card-wrap">
    <!-- body的点击区域 -->
    <section @click="onWrapClick">
      <!-- 头部 -->
      <div class="card-header">
        <!-- 支部名称 -->
        <div class="orgname">{{ party.zoneName }}</div>
        <!-- 管理人 -->
        <div class="org-person">
          <i class="iconfont icon-shujixinxiang"></i>
          <span class="org-person-name">{{party.typeName?party.typeName:'支部书记'}}：{{ party.clerkName }}</span>
        </div>
        <!-- 支部类型 -->
        <div class="org-type" v-if="party.orgTypeName">
          {{ party.orgTypeName }}
        </div>
      </div>

      <!-- 底部选项 -->
      <div class="card-footer">
        <!-- 活动 -->
        <div class="card-footer_item">
          <i class="iconfont icon-huodong-"></i>
          <section>
            <div class="card-footer_item_title">活动</div>
            <div class="card-footer_item_number">
              {{ party.activityCount }}个
            </div>
          </section>
        </div>
        <!-- 上报 -->
        <div class="card-footer_item">
          <i class="iconfont icon-shangbao-"></i>
          <section>
            <div class="card-footer_item_title">上报</div>
            <div class="card-footer_item_number">
              {{ party.reportEventCount }}个
            </div>
          </section>
        </div>
        <!-- 办理 -->
        <div class="card-footer_item">
          <i class="iconfont icon-banli-"></i>
          <section>
            <div class="card-footer_item_title">办理</div>
            <div class="card-footer_item_number">
              {{ party.doneEventCount }}个
            </div>
          </section>
        </div>
      </div>
    </section>
    <!-- 成员数 -->
    <div class="member-wrap">
      <div class="member-title">成员数</div>
      <div class="member-number">{{ party.userCount }}</div>
    </div>
    <!-- 操作选项 -->
    <Poptip class="options" trigger="click" placement="bottom" padding="8px 0">
      <div class="iconfont icon-caidan1 card-menu"></div>
      <div slot="content">
        <div class="options-item" @click="onEdit">编辑</div>
        <div class="options-item" @click="onDelete">删除</div>
      </div>
    </Poptip>
  </Card>
</template>

<script>
export default {
  components: {},
  props: {
    party: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onWrapClick() {
      this.$emit("on-click");
    },
    onEdit() {
      this.$emit("on-edit");
    },
    onDelete() {
      this.$emit("on-delete");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.card-wrap {
  // .flex(center,@flexDirection:column);
}
.card-header {
  .flex(center, center, @flexDirection:column);
  min-height: 190px;
}
.orgname {
  color: #4b4b4b;
  font-size: 24px;
  max-width: 70%;
}
.org-person {
  margin: 10px 0;
}
.org-person-name {
  font-size: 16px;
  font-weight: bold;
}
.org-type {
  color: #fff;
  background-color: #ff7744;
  padding: 4px 10px;
  border-radius: 4px;
}
.icon-shujixinxiang {
  font-size: 16px;
  color: #de200f;
}
.card-footer {
  .flex(center, center);
}
.card-footer_item {
  .flex(center);
  padding: 0 26px;
  border-right: 1px solid #e7e7e7;
  .iconfont {
    font-size: 28px;
    margin-right: 20px;
  }
  &:last-child {
    border-right: none;
  }
  .icon-huodong- {
    color: #feae00;
  }
  .icon-shangbao- {
    color: #55ddb9;
  }
  .icon-banli- {
    color: #3fa0ff;
  }
}
.card-footer_item_title {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}
.card-footer_item_number {
  font-size: 26px;
  color: #333;
  white-space: nowrap;
}
/* 成员数 */
.member-wrap {
  .flex(center, @flexDirection:column);
  position: absolute;
  top: 0;
  left: 20px;

  width: 52px;
  height: 85px;
  background-color: #f95756;
  color: #fff;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    left: -10%;
    bottom: -38%;
    width: 120%;
    height: 50%;
    background-color: #fff;
    border-radius: 50%;
  }
}
.member-title {
  font-size: 14px;
  margin-top: 15px;
}
.member-number {
  font-size: 16px;
}
.options {
  position: absolute;
  top: 20px;
  right: 20px;
}
.card-menu {
  cursor: pointer;
  color: #070707;
}
.options-item {
  padding: 5px;
  text-align: center;
  color: #a6a6a6;
  cursor: pointer;
  &:hover {
    background-color: #f1f1f1;
  }
}
</style>
